<template>
    <div class="border rounded-lgr p-2.5 h-fit flex flex-col gap-2" data-testid="linked-profiles-card">
        <p class="whitespace-nowrap scaffold-body-small-medium flex items-center gap-2">{{ t("profile.collaboration.linkedProfiles.title") }}</p>
        <HorizontalDivider class="my-1" />
        <div class="flex flex-col gap-3 mb-2">
            <BaseLink href="/people/?filter=linked_profiles" class="flex items-baseline gap-2" data-testid="linked-profiles-link">
                <span class="display-serif text-ink" data-testid="linked-profiles-count">{{ formatNumber(linkedCount) }}</span>
                <span class="scaffold-body-small text-ink-muted">{{ t("profile.collaboration.linkedProfiles.countLabel", { count: linkedCount }, linkedCount) }}</span>
            </BaseLink>
            <p class="scaffold-body-small text-ink-muted">{{ t("profile.collaboration.linkedProfiles.description") }}</p>
        </div>
        <BaseButton
            v-if="showAddColleagues"
            theme="primary"
            size="sm"
            class="mt-auto flex gap-2 items-center justify-center animate-shadow-pulse"
            data-testid="add-colleagues-button"
            @click="emit('add-from-organization')">
            <i class="bi bi-boxes text-base/none" aria-hidden="true"></i> {{ t("profile.collaboration.linkedProfiles.addColleagues") }}
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import HorizontalDivider from "~vue/components/HorizontalDivider.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { formatNumber } from "~vue/utils/formatNumber";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const ADD_COLLEAGUES_MAX_LINKS = 3;

const { linkedCount, canAddColleagues = false } = defineProps<{ linkedCount: number; canAddColleagues?: boolean }>();

const emit = defineEmits<{ "add-from-organization": [] }>();

const showAddColleagues = computed(() => canAddColleagues && linkedCount < ADD_COLLEAGUES_MAX_LINKS);
</script>
